// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex-chart-container[data-v-6be5a08c]{display:flex;align-items:space-between}.flex-chart-container .m-chart-block[data-v-6be5a08c]{flex:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
